import ProductReview from './ProductReview';
import RODReviewLinks from './RODReviewLinks';
import RODReviewYotpo from './RODReviewYotpo';
import RODReviewWholescale from './RODReviewWholescale';

/**
 * Action-to-Dialog mapping for ROD items.
 * Mirrors campaigns/activities ACTIONS mapping.
 */
const ROD_DIALOGS = {
  'review_links': RODReviewLinks,
  'review_yotpo': RODReviewYotpo,
  'review_wholescale': RODReviewWholescale,
};

/**
 * Get the appropriate dialog component for an item.
 * @param {Object} item - Feed item { type: 'rod' | 'product', action?, ... }
 * @returns {React.Component} Dialog component
 */
const getDialog = (item) => {
  if (item.type === 'rod' && item.action) {
    return ROD_DIALOGS[item.action] || RODReviewYotpo;
  }
  return ProductReview;
};

const index = {
  ProductReview,
  RODReviewLinks,
  RODReviewYotpo,
  RODReviewWholescale,
  ROD_DIALOGS,
  getDialog,
};

export default index;


